import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Resolve uploaded-image URLs that come back as relative paths
// (e.g. "/api/uploads/xxx.png" or legacy "/uploads/xxx.png") so they can be
// used directly in <img src>.
export function resolveAssetUrl(url) {
    if (!url) return url;
    if (url.startsWith("/api/uploads/") || url.startsWith("/uploads/")) {
        return `${BACKEND_URL}${url}`;
    }
    return url;
}

const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// Bearer fallback (in case third-party cookies are blocked)
let _token = null;
try {
    _token = window.localStorage.getItem("lets_token");
} catch (e) {
    /* ignore */
}
if (_token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${_token}`;
}

export function setAuthToken(token) {
    _token = token;
    try {
        if (token) {
            window.localStorage.setItem("lets_token", token);
            api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        } else {
            window.localStorage.removeItem("lets_token");
            delete api.defaults.headers.common["Authorization"];
        }
    } catch (e) {
        /* ignore */
    }
}

// Global 401 handler: if a session expires mid-flight, clear the stale token and
// bounce the user to /login (but never redirect away from /login or /register).
let _redirecting = false;
api.interceptors.response.use(
    (res) => res,
    (err) => {
        const status = err?.response?.status;
        const url = err?.config?.url || "";
        // Only act on protected routes — leave /auth/login & /auth/me alone so they can
        // surface their own errors to the caller.
        const isAuthCheck = url.includes("/auth/me") || url.includes("/auth/login") || url.includes("/auth/register");
        if (status === 401 && !isAuthCheck && _token) {
            setAuthToken(null);
            if (!_redirecting && typeof window !== "undefined") {
                const path = window.location.pathname;
                if (path !== "/login" && path !== "/register") {
                    _redirecting = true;
                    window.location.replace("/login?expired=1");
                }
            }
        }
        return Promise.reject(err);
    },
);

export function formatApiError(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export default api;
